import { formatCommaNumber } from '@tmap-web-lib/utils'

function formatIntegerKilometers(value: number) {
  return formatCommaNumber(Number(Math.floor(value / 1000)))
}

function formatFloorKilometers(value: number) {
  if (value >= 1000) {
    return `${formatCommaNumber(Number((Math.floor(value / 1000 * 10) / 10).toFixed(1)))}km`
  } else {
    return `${value.toFixed(0)}m`
  }
}

function formatNumericFloorKilometers(value: number) {
  if (value < 1000) return 0
  return Number((Math.floor(value / 1000 * 10) / 10).toFixed(1))
}

function formatMileage(value: number) {
  if (value >= 10000) {
    return `${formatCommaNumber(Number((Math.floor(value / 10000 * 100) / 100).toFixed(1)))}만km`
  } else {
    return `${formatCommaNumber(value)}km`
  }
}

function parseUnit(input: string) {
  const match = input.match(/^([\d.,]+)\s*(km|m)$/i)

  if (!match) {
    throw new Error(`Invalid input: ${input}`)
  }

  const value = parseFloat(match[1].replace(',', ''))
  const unit = match[2].toLowerCase()

  return { value, unit }
}

export {
  formatFloorKilometers,
  formatIntegerKilometers,
  formatNumericFloorKilometers,
  formatMileage,
  parseUnit,
}
